import {
  OutlineButton,
  SolidButton,
} from "@/components/StoreComponents/StoreButton";
import { styled } from "@mui/material";
import React, { useState } from "react";

const LeavingContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.primary.main,
  ".exit-icon": {
    width: "100%",
    minWidth: "300px",
    maxWidth: "300px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "200px",
      minWidth: "200px",
    },
    height: "auto",
    marginBottom: "24px",
  },
  ".image-container": {
    width: "100%",
    minWidth: "300px",
    maxWidth: "300px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "200px",
      minWidth: "200px",
    },
    aspectRatio: "1/1",
    height: "auto",
    marginBottom: "24px",
    position: "relative",
    overflow: "hidden",
    display: "block",
    zIndex: 2,
    transition: "opacity 0.3s ease-in-out",
  },
  ".image-placeholder, .exit-icon": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
  },
  ".image-placeholder": {
    backgroundColor: "#dcdddc",
    opacity: 0.5,
    borderRadius: "100%",
    zIndex: 1,
  },
  ".confirm-text": {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "12px",
    textAlign: "center",
  },
  ".confirm-subtext": {
    fontSize: "16px",
    marginBottom: "24px",
    textAlign: "center",
  },
  ".confirm-buttons": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    [theme.breakpoints.down("xs")]: {
      gap: "8px",
    },
    width: "100%",
  },
}));

const LeavingConfirm = ({
  closeEdit,
  goBack,
}: {
  closeEdit: () => void;
  goBack: () => void;
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <LeavingContainer>
      <div className="image-container">
        {!isLoaded && <div className="image-placeholder" />}
        <img
          className="exit-icon"
          src={"https://media.brandclub.com/brandclub/exit.jpg"}
          alt="exit"
          onLoad={() => setIsLoaded(true)}
          style={{
            opacity: isLoaded ? 1 : 0,
          }}
        />
      </div>
      <div className="confirm-text">Are you sure?</div>
      <div className="confirm-subtext">
        If you leave, all the progress you made will be lost.
      </div>
      <div className="confirm-buttons">
        <SolidButton
          sx={(theme) => ({
            width: "100%",
            maxWidth: "300px",
            [theme.breakpoints.down("md")]: {
              maxWidth: "100%",
            },
          })}
          onClick={closeEdit}
        >
          Yes, exit
        </SolidButton>
        <OutlineButton
          sx={(theme) => ({
            width: "100%",
            maxWidth: "300px",
            [theme.breakpoints.down("md")]: {
              maxWidth: "100%",
            },
          })}
          onClick={goBack}
        >
          No, go back
        </OutlineButton>
      </div>
    </LeavingContainer>
  );
};

export default LeavingConfirm;
